import React, {useCallback, useEffect, useState} from 'react';

export const useDropScaleFile = ({ref, effect, setAnnotation, setScale}) => {
    useEffect(() => {
        ref.current.addEventListener("dragenter", (e) => {
            e.stopPropagation();
            e.preventDefault();
            e.dataTransfer.effectAllowed = "none";
            e.dataTransfer.dropEffect = "none";
        }, false);
    
        ref.current.addEventListener("dragover", (e) => {
            e.stopPropagation();
            e.preventDefault();
            e.dataTransfer.effectAllowed = "none";
            //e.dataTransfer.dropEffect = "none";
            return false;
        });
    
        ref.current.addEventListener("drop", async (ev) => {
            console.log("DROPPING");
            ev.preventDefault();
            ev.stopPropagation();
            ev.dataTransfer.effectAllowed = "none";
            ev.dataTransfer.dropEffect = "none";
            
            if (ev.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                    // If dropped items aren't files, reject them
                    if (ev.dataTransfer.items[i].kind === 'file') {
                        let file = ev.dataTransfer.items[i].getAsFile();
                        let reader = new FileReader();
                        reader.readAsText(file)
                        reader.onloadend = async () => {
                            let text = reader.result;
                            let lines = text.split("\n");
                            let comments = lines.filter(
                                x => x.startsWith("!"))
                                .map(x => x.slice(1).trim()).join("\n");
                            console.log("FILE = ", text,comments);
                            let numbers = [];
                            for (let line of lines) {
                                try {
                                    let number = eval(line);
                                    if (typeof number === "number") {
                                        numbers.push(line);
                                    }
                                } catch (e) {
                                }
                            }
                            console.log("NUMBERS =", numbers);
                            // set the scale
                            numbers[0] = 1;
                            effect.scale = numbers;
                            setScale(numbers);
                            setAnnotation(comments);
                        };
                    }
                }
            } 
            return false;
        });
    }, [setAnnotation, setScale, effect, ref]);
};
